<button class="btn back-btn" (click)="navigateBackToList()">
    <span class="material-symbols-outlined rtl-mirror"> chevron_left</span>
    <span class="back-text"> {{ 'back' | translate }}</span>
</button>
